import React from 'react'

const Footer=()=> {
    return (
        <>
        <div className="footer">
            <div className="footerRows">
            <h3>Vaccination Services</h3> 
            <p><a href="/"> Register Members</a></p>
            <p><a href="/">Search Vaccination Centers</a></p>
            <p><a href="/">Book Vaccination Slots</a></p>
            <p><a href="/">Manage Appointment</a></p>
            <p><a href="/">Download Certificate</a></p>
            </div>

            <div className="footerRows">
            <h3>Platforms</h3> 
            <p><a href="/"> CoWIN International</a></p>
            <p><a href="/">Vaccinator</a></p>
            <p><a href="/">Department Login</a></p>
            <p><a href="/">Verify Certificates</a></p>
            <p><a href="/">Vaccination Statistics</a></p>
            </div>

            <div className="footerRows">
            <h3>Resources</h3> 
            <p><a href="/"> How To Get Vaccinated</a></p>
            <p><a href="/">Dos and Don'ts</a></p>
            <p><a href="/">Overview</a></p>
            <p><a href="/">API Guidelines</a></p>
            <p><a href="/">Grievance Guidelines</a></p>
            </div>

            <div className="footerRows">
            <h3>Support</h3> 
            <p><a href="/"> Frequently Asked Questions</a></p>
            <p><a href="/">Certificate Corrections</a></p>
            <p><a href="/"> Terms of Service</a></p>
            <p><a href="/">Privacy Policy</a></p>
            </div>

            <div className="footerRows">
            <h3>Contact Us</h3> 
            <div className="footerContact">
            <p><a href="/"> Helpline: +91 11 23978046 (Toll Free - 1075 )</a></p>
            <p><a href="/">Technical Helpline: 0120 4473222</a></p>
            </div>
            </div>
        </div>
        <hr />
        <div className="copyright">Copyright © 2021 CoWIN(cloneByDolly). All Rights Reserved</div>
        <hr />

        </>
    )
}

export default Footer;
